<template>
    <div class="product_list_vtwo">
        <!--  home page start  -->
        <!-- Modal -->
        <div
            class="modal home-page-popup fade creat_your_own_popup_custom"
            id="myModal"
            tabindex="-1"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered d-md-flex align-items-center h-100 my-md-0 mb_20 modal-dialog-centered"
            >
                <div class="modal-content">
                    <div class="modal-body d-md-flex p-0">
                        <a
                            href="#"
                            @click="getSelectedValue('close')"
                            id="popup-close"
                            class="popup-close"
                            data-dismiss="modal"
                            ><img src="/maincss/images/cancel.svg" alt=" "
                        /></a>
                        <div class="col-md-6 p-0">
                            <img
                                src="/maincss/images/home-page-popup-image.jpg"
                                alt=" "
                                class="w-100"
                            />
                            <div class="img-overlay text-center">
                                <h4>YOUR</h4>
                                <h1>LOGO</h1>
                                <h4>HERE</h4>
                            </div>
                        </div>
                        <div class="col-md-6 d-md-flex">
                            <div class="popup-content">
                                <h2>Create Your Own Design Instantly</h2>
                                <p>
                                    Simply add your text and explore dozens of
                                    customized layouts.
                                </p>

                                <div class="dropdown">
                                    <a
                                        href="#"
                                        class="btn btn_orange bg_primary_orange text_white w-100 d-none d-md-block"
                                        >Try It</a
                                    >
                                    <a
                                        href="#"
                                        class="btn btn_orange bg_primary_orange text_white w-100 d-block d-md-none dropdown-toggle"
                                        id="dropdownMenuButton"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        >Try It</a
                                    >
                                    <div
                                        class="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton"
                                    >
                                        <router-link
                                            class="dropdown-item"
                                            data-dismiss="modal"
                                            :to="{
                                                path: 'product-list/apparel/28'
                                            }"
                                            @click.native="
                                                getSelectedValue('T-shirt')
                                            "
                                        >
                                            T-Shirt
                                        </router-link>
                                        <router-link
                                            @click.native="
                                                getSelectedValue('Hats')
                                            "
                                            class="dropdown-item"
                                            :to="{
                                                path: '/product-list/apparel/86'
                                            }"
                                            data-dismiss="modal"
                                            >Hats</router-link
                                        >
                                        <router-link
                                            @click.native="
                                                getSelectedValue('Bags')
                                            "
                                            class="dropdown-item"
                                            :to="{
                                                path: '/product-list/apparel/74'
                                            }"
                                            data-dismiss="modal"
                                            >Bags</router-link
                                        >
                                        <router-link
                                            @click.native="
                                                getSelectedValue(
                                                    'Design Studio'
                                                )
                                            "
                                            data-dismiss="modal"
                                            class="btn btn-outline-primary border_primary_blue text_primary_blue"
                                            :to="{ name: 'DesignStudioV3' }"
                                            >Design Studio</router-link
                                        >
                                    </div>
                                </div>
                                <div class="mt_24">
                                    <a
                                        href="javascript:void(0)"
                                        class="btn-link mt_24"
                                        data-dismiss="modal"
                                        >No thanks, I want to start from
                                        scratch</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- hero_banner section -->
        <section class="cmn-section hero_banner">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-12 p-0 d-block d-md-none">
                        <img
                            src="/maincss/images/mobile_bannner2x.png"
                            alt="hero_banner_image"
                        />
                    </div>
                    <div class="col-md-7 col-lg-6">
                        <h2>Customize</h2>
                        <h1>Your Design</h1>
                        <p>Orders Shipped as Quick as Tomorrow!</p>

                        <div class="button_action">
                            <a
                                href="#"
                                class="btn btn_primary bg_primary_blue text_white"
                                >browse</a
                            >
                            <router-link
                                :to="{ path: '/category/apparel' }"
                                class="btn btn_orange bg_primary_orange text_white"
                            >
                                shop now</router-link
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="cmn-section shipping-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 d-flex">
                        <div class="shipping-step">
                            <ul class="mb-0">
                                <li>
                                    <img
                                        src="/maincss/images/delivery-truck.svg"
                                        alt=""
                                    /><span>
                                        FREE SHIPPING <br />
                                        Select Items</span
                                    >
                                </li>
                                <li>
                                    <img
                                        src="/maincss/images/accounting.svg"
                                        alt=""
                                    /><span>
                                        Bulk Order <br />
                                        Pricing</span
                                    >
                                </li>
                                <li>
                                    <img
                                        src="/maincss/images/calendar.svg"
                                        alt=""
                                    />
                                    <span
                                        >FAST <br />
                                        DELIVERY</span
                                    >
                                </li>
                                <li>
                                    <img
                                        src="/maincss/images/light-bulb.svg"
                                        alt=""
                                    /><span>
                                        FREE <br />
                                        Design Ideas</span
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Adds section -->
        <section class="cmn-section adds-section pt-0">
            <div class="container">
                <div class="row">
                    <div
                        class="col-md-12 col-lg-4 custom-padding"
                        data-aos="fade-up"
                        data-aos-delay="100"
                        data-aos-offset="100"
                    >
                        <div class="adds-box adds_box_full_grow">
                            <img
                                src="/maincss/images/add1.png"
                                alt=""
                                class="img-fluid"
                            />

                            <div class="download-search">
                                <input
                                    type="text"
                                    name="email"
                                    placeholder="Enter email to download"
                                />
                                <button
                                    class="btn btn_yellow bg_primary_yellow text_black"
                                >
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>

                    <div
                        class="col-md-6 col-lg-4 custom-padding w-md-auto"
                        data-aos="fade-up"
                        data-aos-delay="100"
                        data-aos-offset="100"
                    >
                        <div class="adds-box">
                            <img
                                src="/maincss/images/add2.png"
                                alt=""
                                class="img-fluid"
                            />

                            <div class="download-search">
                                <a
                                    href="#"
                                    class="btn btn_primary bg_primary_blue text_white"
                                    >Get Report</a
                                >
                            </div>
                        </div>
                    </div>

                    <div
                        class="col-md-6 col-lg-4 custom-padding"
                        data-aos="fade-up"
                        data-aos-delay="100"
                        data-aos-offset="100"
                    >
                        <div class="adds-box">
                            <img
                                src="/maincss/images/add3.png"
                                alt=""
                                class="img-fluid"
                            />

                            <div class="download-search">
                                <a
                                    href="#"
                                    class="btn btn_primary bg_primary_blue text_white"
                                    >Get Report</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section
            v-if="feature_product_list.length > 0"
            class="cmn-section featured-products-section pt-0 pb_25 f-p-s-image"
        >
            <div class="container">
                <div class="row">
                    <div
                        class="col-md-12"
                        data-aos="fade-up"
                        data-aos-offset="100"
                    >
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Featured Products</span
                                >
                            </h1>
                            <h3 class="sub_heading1 text-center mt_6 mb-0">
                                Our Best Selling Items
                            </h3>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <ProductListGrid
                            :product_object="feature_product_list"
                            :columns="'4'"
                        ></ProductListGrid>
                    </div>
                </div>
            </div>
        </section>

        <!-- Custom section -->
        <section class="cmn-section offer-section pt-0">
            <div class="container">
                <div class="row">
                    <div
                        class="col-md-12"
                        data-aos="fade-up"
                        data-aos-offset="100"
                    >
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Custom your design</span
                                >
                            </h1>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div
                            class="custom-banner"
                            data-aos="fade-up"
                            data-aos-offset="100"
                        >
                            <div class="row align-items-center">
                                <div class="col-sm-6">
                                    <div class="custom-img">
                                        <img
                                            src="/maincss/images/custom2x.png"
                                            alt=""
                                        />
                                    </div>
                                    <div class="offer">
                                        <img
                                            src="/maincss/images/offer.png"
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="custom-caption">
                                        <h4>Best Seller</h4>
                                        <h2>Custom Apparel</h2>
                                        <p>
                                            Call us today and find out how you
                                            can leave a lasting impression at
                                            your next event!
                                        </p>
                                        <router-link
                                            class="btn btn_orange bg_primary_orange text_white"
                                            id="navbarDropdown"
                                            role="button"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            :to="{ path: '/category/apparel' }"
                                            >Shop Now</router-link
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- explore section -->
        <section class="cmn-section explore-section pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Explore more</span
                                >
                            </h1>
                            <h3 class="sub_heading1 text-center mt_6 mb-0">
                                Popular Categories
                            </h3>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="explore-box">
                            <div
                                class="explore-left-box box-explore-animation align-items-center"
                                data-aos="fade-up"
                                data-aos-offset="100"
                                data-aos-delay="100"
                            >
                                <img
                                    src="/maincss/images/cap.png"
                                    class="explore-product"
                                    alt=" product image"
                                />

                                <div>
                                    <h3>Custom cap</h3>
                                    <p>Custom Classic Soft</p>
                                    <router-link
                                        class="btn btn_white bg_primary_light_white text_primary_orange"
                                        :to="{ name: 'hats' }"
                                        >Explore</router-link
                                    >
                                </div>
                            </div>
                            <div class="explore-right-box">
                                <div
                                    class="explore-top-box"
                                    data-aos="fade-up"
                                    data-aos-offset="100"
                                    data-aos-delay="100"
                                >
                                    <div class="row align-items-center">
                                        <div class="col-6 custom-md-6">
                                            <h3>Best Seller</h3>
                                            <h2>Custom bag</h2>
                                            <router-link
                                                class="btn btn_orange bg_primary_orange text_white"
                                                :to="{ name: 'bags' }"
                                                >Explore</router-link
                                            >
                                            <!-- <a
                        href="#"
                        class="btn btn_orange bg_primary_orange text_white"
                        >Explore</a
                      > -->
                                        </div>
                                        <div class="col-6 custom-md-6">
                                            <div class="beg-img">
                                                <img
                                                    src="/maincss/images/beg.png"
                                                    class="explore-product"
                                                    alt=" product image"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="explore-bottom-box">
                                    <div
                                        class="tshit-box"
                                        data-aos="fade-up"
                                        data-aos-offset="100"
                                        data-aos-delay="100"
                                    >
                                        <img
                                            src="/maincss/images/tshit.png"
                                            class="explore-product"
                                            alt=" product image"
                                        />

                                        <div class="tshirt-content">
                                            <h4>T-SHIRT</h4>
                                            <router-link
                                                class="btn btn_orange bg_primary_orange text_white"
                                                :to="{
                                                    path: '/category/apparel'
                                                }"
                                                >Explore</router-link
                                            >
                                        </div>
                                    </div>
                                    <div
                                        class="cup-box align-items-center"
                                        data-aos="fade-up"
                                        data-aos-offset="100"
                                        data-aos-delay="100"
                                    >
                                        <div class="cup-content">
                                            <h4>Cup</h4>
                                            <p>
                                                Classic styles and comfortable
                                                <br />
                                                fits for the whole crew.
                                            </p>
                                            <router-link
                                                class="btn btn_white bg_primary_light_white text_primary_orange mb_20"
                                                :to="{
                                                    path: '/category/apparel'
                                                }"
                                                >Explore</router-link
                                            >
                                        </div>
                                        <img
                                            src="/maincss/images/ycup.png"
                                            class="explore-product"
                                            alt=" product image"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Testimonials section -->

        <section class="cmn-section testemonial_section pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Testimonials</span
                                >
                            </h1>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="owl-carousel testemonial mx-auto mt_50">
                            <div
                                class="item"
                                v-for="testimonial in testimonial_list"
                                :key="testimonial.id"
                            >
                                <div class="testemonial_content text-center">
                                    <p class="text_black font_size_15">
                                        {{ testimonial.description }}
                                    </p>
                                    <div class="user_image mx-auto mt_30">
                                        <img
                                            :src="testimonial.userphoto"
                                            alt=" "
                                        />
                                    </div>
                                    <div class="user_content">
                                        <h4 class="font_size_22 mt_22">
                                            {{ testimonial.username }}
                                        </h4>
                                        <div
                                            class="rating d-flex mx-auto justify-content-center align-items-center"
                                        >
                                            <img
                                                src="/maincss/images/star.svg"
                                                alt=" "
                                                class="mw-auto w-auto mr_10"
                                                v-for="n in testimonial.rating"
                                                :key="'image' + n"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- shop_by_brand section -->

        <section
            class="cmn-section shop_by_brand pt-0"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-offset="100"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Shop By Brand</span
                                >
                            </h1>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div
                            class="owl-carousel shop_by_brand_logo col-md-12 d-flex pl_50 pr_46"
                        >
                            <div
                                class="item"
                                v-for="(brands, key) in brand_list"
                                :key="'brands' + key"
                            >
                                <div
                                    class="brand_logo d-block text-center"
                                    v-for="(brand, index) in brands"
                                    :key="'brand' + index"
                                >
                                    <router-link
                                        :to="{
                                            path:
                                                '/brand/' +
                                                (brand.slug
                                                    ? brand.slug
                                                    : brand.id)
                                        }"
                                    >
                                        <img
                                            :src="brand.logo_file"
                                            alt="brand_logo"
                                            class="w-100 m-auto"
                                        />
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- socila_media_post section -->

        <section class="cmn-section socila_media_post py-0 mb_60">
            <div class="container">
                <div class="row">
                    <div
                        class="col-md-12"
                        data-aos="fade-up"
                        data-aos-offset="500"
                    >
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Follow us on Instagram</span
                                >
                            </h1>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="owl-carousel social_media">
                            <div class="item">
                                <div class="insta_feed position-relative">
                                    <img
                                        src="/maincss/images/instagram_1.png"
                                        alt=" "
                                        class="w-100"
                                    />
                                    <div
                                        class="insta_feed_content d-flex justify-content-center align-items-center text-center flex-column"
                                    >
                                        <div class="likes_coments d-flex">
                                            <div
                                                class="likes d-flex justify-content-center align-items-center"
                                            >
                                                <img
                                                    src="/maincss/images/heart_outline_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    1.7k
                                                </p>
                                            </div>
                                            <div
                                                class="likes d-flex justify-content-center align-items-center ml_44"
                                            >
                                                <img
                                                    src="/maincss/images/question_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    31
                                                </p>
                                            </div>
                                        </div>
                                        <p
                                            class="font_size_13 text_white mt_32"
                                        >
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="insta_feed position-relative">
                                    <img
                                        src="/maincss/images/instagram_2.png"
                                        alt=" "
                                        class="w-100"
                                    />
                                    <div
                                        class="insta_feed_content d-flex justify-content-center align-items-center text-center flex-column"
                                    >
                                        <div class="likes_coments d-flex">
                                            <div
                                                class="likes d-flex justify-content-center align-items-center"
                                            >
                                                <img
                                                    src="/maincss/images/heart_outline_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    1.7k
                                                </p>
                                            </div>
                                            <div
                                                class="likes d-flex justify-content-center align-items-center ml_44"
                                            >
                                                <img
                                                    src="/maincss/images/question_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    31
                                                </p>
                                            </div>
                                        </div>
                                        <p
                                            class="font_size_13 text_white mt_32"
                                        >
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="insta_feed position-relative">
                                    <img
                                        src="/maincss/images/instagram_4.png"
                                        alt=" "
                                        class="w-100"
                                    />
                                    <div
                                        class="insta_feed_content d-flex justify-content-center align-items-center text-center flex-column"
                                    >
                                        <div class="likes_coments d-flex">
                                            <div
                                                class="likes d-flex justify-content-center align-items-center"
                                            >
                                                <img
                                                    src="/maincss/images/heart_outline_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    1.7k
                                                </p>
                                            </div>
                                            <div
                                                class="likes d-flex justify-content-center align-items-center ml_44"
                                            >
                                                <img
                                                    src="/maincss/images/question_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    31
                                                </p>
                                            </div>
                                        </div>
                                        <p
                                            class="font_size_13 text_white mt_32"
                                        >
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="insta_feed position-relative">
                                    <img
                                        src="/maincss/images/instagram_3.png"
                                        alt=" "
                                        class="w-100"
                                    />
                                    <div
                                        class="insta_feed_content d-flex justify-content-center align-items-center text-center flex-column"
                                    >
                                        <div class="likes_coments d-flex">
                                            <div
                                                class="likes d-flex justify-content-center align-items-center"
                                            >
                                                <img
                                                    src="/maincss/images/heart_outline_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    1.7k
                                                </p>
                                            </div>
                                            <div
                                                class="likes d-flex justify-content-center align-items-center ml_44"
                                            >
                                                <img
                                                    src="/maincss/images/question_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    31
                                                </p>
                                            </div>
                                        </div>
                                        <p
                                            class="font_size_13 text_white mt_32"
                                        >
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="insta_feed position-relative">
                                    <img
                                        src="/maincss/images/instagram_4.png"
                                        alt=" "
                                        class="w-100"
                                    />
                                    <div
                                        class="insta_feed_content d-flex justify-content-center align-items-center text-center flex-column"
                                    >
                                        <div class="likes_coments d-flex">
                                            <div
                                                class="likes d-flex justify-content-center align-items-center"
                                            >
                                                <img
                                                    src="/maincss/images/heart_outline_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    1.7k
                                                </p>
                                            </div>
                                            <div
                                                class="likes d-flex justify-content-center align-items-center ml_44"
                                            >
                                                <img
                                                    src="/maincss/images/question_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    31
                                                </p>
                                            </div>
                                        </div>
                                        <p
                                            class="font_size_13 text_white mt_32"
                                        >
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="item"
                                v-for="(instaFeed, indx) in insta_data"
                                :key="indx"
                            >
                                <div class="insta_feed position-relative">
                                    <img
                                        src="/maincss/images/instagram_3.png"
                                        alt=" "
                                        class="w-100"
                                    />
                                    <div
                                        class="insta_feed_content d-flex justify-content-center align-items-center text-center flex-column"
                                    >
                                        <div class="likes_coments d-flex">
                                            <div
                                                class="likes d-flex justify-content-center align-items-center"
                                            >
                                                <img
                                                    src="/maincss/images/heart_outline_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    1.7k
                                                </p>
                                            </div>
                                            <div
                                                class="likes d-flex justify-content-center align-items-center ml_44"
                                            >
                                                <img
                                                    src="/maincss/images/question_white.svg"
                                                    alt=" "
                                                />
                                                <p
                                                    class="font_size_12 text_white ml_6 mb-0 w-100"
                                                >
                                                    31
                                                </p>
                                            </div>
                                        </div>
                                        <p
                                            class="font_size_13 text_white mt_32"
                                        >
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--  home page end  -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import ProductListGrid from "./products/ProductListGrid";
import JwtService from "@/common/jwt.service";
export default {
    /* eslint-disable */
    name: "home",
    /* eslint-enable */
    components: {
        ProductListGrid
    },
    data() {
        return {
            testimonial_list: [],
            brand_list: [],
            feature_product_list: [],
            feature_product_list_ids: [],
            insta_data: [],
            favourite_product_ids: [],
            all_colors_list: [],
            markup_tiers: []
        };
    },
    created() {
        
        const token = this.$route.query.token;
        const admin_user_id = this.$route.query.admin_user_id;

        if (token) {
            window.localStorage.setItem("adminLoggedIn", true);
            window.localStorage.setItem("admin_user_id", admin_user_id);
            JwtService.saveToken(token);
            

            // Wait until Vue finishes updates before replacing route
            /* this.$nextTick(() => {
                this.$router.replace({ path: "/", query: {} });
            }); */
             // Wait until Vue finishes updates before replacing route
        this.$nextTick(() => {
            this.$router.replace({ path: "/", query: {} }).then(() => {
               // this.emptyAllCartItems();
                // Force a full page reload
                //window.location.reload();
            });
        });
        }
    },
    mounted() {
        /* eslint-disable */
        if (
            localStorage.getItem("home_selected_value") == "" ||
            localStorage.getItem("home_selected_value") == null
        ) {
            $("#myModal").modal("show");
        } else {
            $("#myModal").modal("hide");
        }
        /* eslint-enable */
        document.body.classList.remove("bg_primary_light_white");
        /* eslint-disable */
        AOS.init();
        
        // Load page data and initialize carousels after data loads
        this.onLoadPage().then(() => {
            // Initialize carousels after data is loaded
            this.$nextTick(() => {
                // Wait for DOM elements to be ready, especially on development server
                const initCarousels = () => {
                    if (typeof $ !== 'undefined' && $.fn.owlCarousel) {
                        // Check if elements exist before initializing
                        if ($(".testemonial").length > 0) {
                            $(".testemonial").owlCarousel({
                                loop: false,
                                margin: 86,
                                nav: true,
                                dots: true,
                                responsive: {
                                    1: { items: 1 },
                                    600: { items: 1 },
                                    1000: { items: 2, margin: 10 },
                                    1200: { items: 2 }
                                }
                            });
                        }
                        
                        if ($(".shop_by_brand_logo").length > 0) {
                            $(".shop_by_brand_logo").owlCarousel({
                                loop: false,
                                margin: 0,
                                nav: true,
                                dots: false,
                                responsiveClass: true,
                                responsive: {
                                    1: { items: 1 },
                                    768: { items: 2 },
                                    1000: { items: 5 },
                                    1200: { items: 6 }
                                }
                            });
                        }
                        
                        if ($(".social_media").length > 0) {
                            $(".social_media").owlCarousel({
                                loop: true,
                                margin: 40,
                                nav: true,
                                dots: false,
                                responsive: {
                                    1: { items: 1 },
                                    600: { items: 2 },
                                    1000: { items: 3, margin: 10 },
                                    1200: { items: 4 }
                                }
                            });
                        }
                    } else {
                        // Retry if jQuery or owlCarousel not ready yet
                        setTimeout(initCarousels, 200);
                    }
                };
                
                // Start initialization with a reasonable delay for development server
                setTimeout(initCarousels, 1000);
            });
        });

        
        /* eslint-enable */
    },
    methods: {
        async onLoadPage() {
            // First load colors and markup tiers (needed for product processing)
            await Promise.all([
                this.getAllColors(),
                this.getAllMarkupTiers()
            ]);
            
            // Then load products (depends on colors), testimonials, and brands in parallel
            await Promise.all([
                this.getFeatureProducts(),
                this.getTestimonials(),
                this.getBrands()
            ]);
        },
         getCart() {
            var _this = this;

            if (_this.currentUserClient.id) {
                new Promise(() => {
                    ApiService.get("/cart-items-quantity")
                        .then(({ data }) => {
                            _this.cart_total_items = data.total_items;
                        })
                        .catch(({ response }) => {
                            console.log(response);
                        });
                });
            } else {
                if (localStorage.getItem("cart")) {
                    _this.cart_items = JSON.parse(localStorage.getItem("cart"));
                    _this.cart_total_items = _this.cart_items.length;
                } else {
                    _this.cart_items = [];
                    _this.cart_total_items = 0;
                }
            }
        },
         emptyAllCartItems() {
            var _this = this;
            localStorage.removeItem("cart");
            localStorage.setItem("cartNotEmpty", false);
            _this.cart_items = [];

            if (_this.currentUserClient.id) {
                _this.isBusy = true;
                ApiService.post("/empty-cart")
                    .then(() => {
                      
                        _this.getCart();
                        _this.$root.$emit("update-cart");
                        _this.isBusy = false;
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isBusy = false;
                    });
            } else {
                _this.$root.$emit("update-cart");
              
            }
        },
        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        },
        getSelectedValue(value) {
            localStorage.setItem("home_selected_value", value);
        },
        getPromotionCoast(product) {
            let promotinovalues = JSON.parse(product.promotion_values);
            var today = new Date();
            var enddate = new Date(promotinovalues.end_date);
            var startdate = new Date(promotinovalues.start_date);

            let retunvalue = "";
            if (enddate >= today && startdate <= today) {
                if (promotinovalues.promotion_product_value) {
                    retunvalue = Number(
                        promotinovalues.promotion_product_value
                    ).toFixed(2);
                }

                if (promotinovalues.promotion_product_type == "Flat") {
                    retunvalue = "-$" + retunvalue;
                } else {
                    retunvalue = "-" + retunvalue + "%";
                }
            }
            return retunvalue;
        },
        discountedPrice(product) {
            let promotinovalues = JSON.parse(product.promotion_values);
            let final_price = 0;
            let retail_price = Number(product.retail_base_price);
            let discount_value = Number(
                promotinovalues.promotion_product_value
            );
            if (promotinovalues.promotion_product_type == "Percent") {
                final_price = retail_price * ((100 - discount_value) / 100);
            } else {
                final_price = retail_price - discount_value;
            }

            return final_price.toFixed(2);
        },
        productImage(images) {
            return images[0]
                ? images[0].image_path
                : "/maincss/images/featured_product_1.png";
        },
        productColors(colors) {
            return colors ? JSON.parse(colors) : colors;
        },
        discountPercentage(product) {
            let discount = product.mark_up_value;

            let display_value =
                product.mark_up_type == "Percent"
                    ? discount.toFixed(2) + "%"
                    : "$" + discount; //+++++ 09-15-2021 show markup value in discount column
            return "-" + display_value;
        },
        getFeatureProducts() {
            return new Promise((resolve, reject) => {
                ApiService.get("/home-new-products")
                    .then(async ({ data }) => {
                        this.feature_product_list = data.products.filter(
                            (product) => product.MainNewSubProducts.length > 0
                        );
                        this.feature_product_list.forEach((product) => {
                            product["default_color_id"] = null;
                            let sub_product = product.MainNewSubProducts.find(
                                (sub_product) => sub_product.default_selection
                            );
                            if (sub_product) {
                                product["default_color_id"] =
                                    sub_product.color_id;
                            }

                            let color_ids = product.color_ids
                                ? JSON.parse(product.color_ids)
                                : [];
                            product.colors = this.all_colors_list.filter(
                                (color) => color_ids.includes(color.id)
                            );

                            if (
                                product.decoration_price_type == "global_price"
                            ) {
                                product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        product.price_base,
                                        product.decoration_type,
                                        product.decoration_price_template
                                    );
                                product.price_markup_value =
                                    (parseFloat(product.price_base) *
                                        parseFloat(
                                            product.price_markup_percentage
                                        )) /
                                    100;
                                if (product.decoration_type == 1) {
                                    let decoration_price_template =
                                        this.printTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.PrintTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify({
                                                print_location1:
                                                    decoration_price_template.PrintLocation1Templates
                                            });
                                    }
                                } else if (product.decoration_type == 2) {
                                    let decoration_price_template =
                                        this.embroideryTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.EmbroideryTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify(
                                                decoration_price_template.EmbroideryQuantities
                                            );
                                    }
                                }
                            }
                        });

                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        groupArrayOfObjects(list, key) {
            return list.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        getBrands() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/home-brands")
                    .then(({ data }) => {
                        const items = data.brands.filter(
                            (brand) => brand.show_on_home == 1
                        ); //… your array, filled with values
                        const n = 3; //tweak this to add more items per line
                        /* eslint-disable */
                        const result = new Array(Math.ceil(items.length / n))
                            .fill()
                            .map((_) => items.splice(0, n));
                        _this.brand_list = result;
                        /* eslint-enable */
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            });
        },
        getTestimonials() {
            new Promise(() => {
                ApiService.get("/home-testimonials")
                    .then(({ data }) => {
                        this.testimonial_list = data.testimonials;
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            });
        },
        followUsOnInstagram() {
            new Promise(() => {
                ApiService.get("/followUsOnInstagram")
                    .then(({ data }) => {
                        this.insta_data = data.instaData;
                    })
                    .catch(() => {
                        // console.log(response);
                    });
            });
        },
        getInstaImage(file) {
            const p = file.split("/");
            var t = "";
            for (let i = 0; i < p.length; i++) {
                if (i == 2) {
                    t +=
                        p[i].replaceAll("-", "--").replaceAll(".", "-") +
                        atob("LnRyYW5zbGF0ZS5nb29n") +
                        "/";
                } else {
                    if (i != p.length - 1) {
                        t += p[i] + "/";
                    } else {
                        t += p[i];
                    }
                }
            }
            return encodeURI(t);
        },
        getAllFavoriteProducts() {
            return new Promise(() => {
                ApiService.post("/get-favorite-by-product-ids", {
                    ids: this.feature_product_list_ids
                })
                    .then(({ data }) => {
                        let favourite_product_ids = data.favorite.map(
                            (product) => product.product_id
                        );
                        this.feature_product_list.forEach((feature_product) => {
                            this.$refs[
                                `bottom-links-${feature_product.id}`
                            ][0].is_favorite_product =
                                favourite_product_ids.includes(
                                    feature_product.id
                                );
                            this.$refs[
                                `bottom-links-${feature_product.id}`
                            ][0].favorite_product = data.favorite.find(
                                (fav) => fav.product_id == feature_product.id
                            );
                        });
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            });
        },
        getAllColors() {
            return new Promise((resolve, reject) => {
                ApiService.post("/all-colors", {
                    attributes: ["id", "name", "hex", "swatches"]
                })
                    .then(({ data }) => {
                        this.all_colors_list = data.colors;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        }
    },
    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "printTemplates",
            "embroideryTemplates"
        ])
    }
};
</script>
